import "/sentry.client.config.ts"
import { defineNuxtPlugin } from "#imports"
export default defineNuxtPlugin(() => {})